var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDriver = function SvgDriver(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "driver_svg__a",
    width: 18,
    height: 18,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h18v18H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 1.2,
    mask: "url(#driver_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M5 5a4 4 0 1 1 8 0 4 4 0 0 1-8 0"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M16.97 15.353A1.37 1.37 0 0 1 15.62 17H2.38a1.37 1.37 0 0 1-1.35-1.647C1.8 11.703 5.075 9 9 9c2.82 0 5.306 1.377 6.767 3.529"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M1.03 15.353A1.37 1.37 0 0 0 2.38 17h13.24a1.37 1.37 0 0 0 1.35-1.647C16.2 11.703 12.925 9 9 9c-2.82 0-5.306 1.377-6.767 3.529"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 17c0-2.761 1.79-5 4-5s4 2.239 4 5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12 14-1.812 1.541c-.353.3-.775.46-1.207.459a1.85 1.85 0 0 1-1.205-.468L6 14"
  }))));
};
export default SvgDriver;